<template>
    <form>
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div v-if="EvaluationForm.isEditable" class="col-lg-9">
                        <table
                            class="table-bordered table-full-width"
                            cellpadding="20"
                        >
                        
                            <tr>
                                <td>
                                    {{
                                        $t(
                                            "rapid_response_grant_ev.technical__grid_download"
                                        )
                                    }}
                                </td>
                                <td
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <a
                                        :href="downloadFiles[0][$i18n.locale]"
                                        class="ml-2 btn btn-simple btn-primary"
                                    >
                                        {{
                                            $t(
                                                "small_technical_grants.document_upload__download_template_button_title"
                                            )
                                        }}
                                        <i
                                            class="tim-icons icon-cloud-download-93 ml-2"
                                        ></i>
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-lg-9 mt-4">
                        <table
                        class="table-bordered table-full-width"
                            cellpadding="10"
                            v-if="loggedUser.role == 'EVALUATOR'"
                        >
                          <!-- evaluator doc upload-->
                            <tr v-for="(item, index) in EvaluationForm.model.evaluation_docs" :key="'evaluator_'+index" v-if="loggedUser.id == item.created_by_id">
                                <th>
                                    {{
                                            $t(
                                                "medium_grant_cn_ev.evaluator_name_label"
                                            )
                                        }}
                                </th>
                                <td
                                  class="text-center"
                                    style="min-width: 200px"
                                >
                                    <!--{{item.evaluator_name}}-->
                                    <textarea
                                        class="form-control mt-5"
                                        :placeholder="$t('general.write_here')"
                                        v-model="item.evaluator_name"
                                    >
                                    </textarea>
                                </td>
                                <th>
                                  Final Score
                                </th>
                                <td
                                    class="text-center"
                                    style="min-width: 100px"
                                >
                                    <div class="form-group mb-0 mt-2">
                                        <label for="item.final_score">{{
                                            $t(
                                                "small_technical_grants_ev.technical__final_score"
                                            )
                                        }}</label>
                                        <input
                                            type="text"
                                            name="item.final_score"
                                            v-model="item.final_score"
                                            :disabled="loggedUser.role == 'EVALUATOR' && item.evaluator_name != loggedUser.name"
                                        />
                                        <!--<small>{{
                                            $t(
                                                "rapid_response_grant_ev.technical__final_score_from_info"
                                            )
                                        }}</small>-->
                                    </div>
                                </td>
                                <!--<th
                                    style="max-width: 100px"
                                >
                                  Upload completed evaluation grid
                                </th>-->
                                <td
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <upload-file
                                        v-model="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :select-text="
                                            $t(
                                                'medium_grant_ev.esmsc__upload_evaluation'
                                            )
                                        "
                                        :is-evaluation="true"
                                        :file-data="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :is-editable="EvaluationForm.isEditable"
                                        :size-limit="EvaluationForm.fileSizeLimit"
                                        :section="'cntechnical.evaluation_docs' + (index + 1)"
                                    ></upload-file>
                                </td>
                            </tr>
                        </table>
                        <!-- Table For Admin Users -->
                        <table
                        class="table-bordered table-full-width"
                            cellpadding="10"
                            v-if="loggedUser.role != 'EVALUATOR'"
                        >
                          <!-- evaluator doc upload-->
                            <tr v-for="(item, index) in EvaluationForm.model.evaluation_docs" :key="'evaluator_'+index">
                                <th>
                                    {{
                                            $t(
                                                "medium_grant_cn_ev.evaluator_name_label"
                                            )
                                        }}
                                </th>
                                <td
                                  class="text-center"
                                    style="min-width: 200px"
                                >
                                    <!--{{item.evaluator_name}}-->
                                    <textarea
                                        class="form-control mt-5"
                                        :placeholder="$t('general.write_here')"
                                        v-model="item.evaluator_name"
                                    >
                                    </textarea>
                                </td>
                                <th>
                                  Final Score
                                </th>
                                <td
                                    class="text-center"
                                    style="min-width: 100px"
                                >
                                    <div class="form-group mb-0 mt-2">
                                        <label for="item.final_score">{{
                                            $t(
                                                "small_technical_grants_ev.technical__final_score"
                                            )
                                        }}</label>
                                        <input
                                            type="text"
                                            name="item.final_score"
                                            v-model="item.final_score"
                                            :disabled="loggedUser.role == 'EVALUATOR' && item.evaluator_name != loggedUser.name"
                                        />
                                        <!--<small>{{
                                            $t(
                                                "rapid_response_grant_ev.technical__final_score_from_info"
                                            )
                                        }}</small>-->
                                    </div>
                                </td>
                                <!--<th
                                    style="max-width: 100px"
                                >
                                  Upload completed evaluation grid
                                </th>-->
                                <td
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <upload-file
                                        v-model="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :select-text="
                                            $t(
                                                'medium_grant_ev.esmsc__upload_evaluation'
                                            )
                                        "
                                        :is-evaluation="true"
                                        :file-data="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :is-editable="EvaluationForm.isEditable"
                                        :size-limit="EvaluationForm.fileSizeLimit"
                                        :section="'cntechnical.evaluation_docs' + (index + 1)"
                                    ></upload-file>
                                </td>
                            </tr>
                        </table>
                            <base-button
                            v-if="loggedUser.role == 'ADMIN' || loggedUser.role =='REGIONAL_ADMIN'  && EvaluationForm.isEditable"
                            type="primary"
                            @click.native="addNewEvaluator"
                            class=""
                            >
                            <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
                            </base-button>
                    </div>
                    <div class="col-lg-3 mt-4">
                        <info-right></info-right>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { EvaluationForm } from "@/services";
import InfoRight from "./InfoRight";
import ApplicationInfo from "../ApplicationInfo";
import { CommentBox } from "src/components";
import { Select, Option } from "element-ui";

export default {
    components: {
        ApplicationInfo,
        InfoRight,
        CommentBox,
        loggedUser:{},
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            EvaluationForm,
            technichaltemplateName : '',
            downloadFiles: [
                {
                    en: '/files/en/MG/FP/Region/'+EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx',
                    fr: '/files/fr/MG/FP/Region/'+EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx'
                }
            ]
        };
    },
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser']; 
    },
    beforeCreate() {
        if (!EvaluationForm.files.cntechnical) {
            EvaluationForm.files.cntechnical = {};
        }
    },
    mounted(){
      let vm =this;
      //Add new row to evaluation grid
      if(vm.EvaluationForm.isEditable){
      if (!vm.EvaluationForm.model.evaluation_docs) {
          vm.EvaluationForm.model.evaluation_docs = [];
          vm.EvaluationForm.model.evaluation_docs.push(
              {evaluator_name : this.loggedUser.name,
              final_score : 0,
              created_by_name : this.loggedUser.name
              ,created_by_id : this.loggedUser.id});
            this.$forceUpdate();
      }
      else{
            let fg = 0;
            for (let i = 0; i < vm.EvaluationForm.model.evaluation_docs.length; i++) {
              if(this.loggedUser.id == vm.EvaluationForm.model.evaluation_docs[i].created_by_id){
                  fg = 1;
              }
            }
            if(fg == 0){
              vm.EvaluationForm.model.evaluation_docs.push(
                  {evaluator_name : this.loggedUser.name,
                  final_score : 0,
                  created_by_name : this.loggedUser.name,
                  created_by_id : this.loggedUser.id});
              this.$forceUpdate();
            }
      }
      }

        //Regionwise template name
    if(vm.EvaluationForm.application.region_id == 5 || vm.EvaluationForm.application.region_id == 6){
        vm.technichaltemplateName = 'MG_ESA_technical_evaluation_grid_FP_v1'
    }
    vm.downloadFiles = [{
                    en: '/files/en/MG/FP/Region/'+this.EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx',
                    fr: '/files/fr/MG/FP/Region/'+this.EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx'
                }]

    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        },
        addNewEvaluator()
        {
            /*if (!EvaluationForm.model.evaluation_docs)
            {
            EvaluationForm.model.evaluation_docs = [];
            }*/

            EvaluationForm.model.evaluation_docs.push(
                {evaluator_name : '',
                final_score : 0,
                created_by_name : this.loggedUser.name,
                created_by_id : this.loggedUser.id});
            this.$forceUpdate();
        },
    }
};
</script>
<style scoped>
textarea {
    resize: vertical !important;
}
</style>
